import React from 'react';
import classnames from 'classnames';
import { FieldBuilderRedesigned } from 'new/elements/FieldBuilderRedesigned/FieldBuilder';

import styles from './IncomingWebhookConfiguration.module.scss';

const InputTypes = ['hash_algorithm', 'hash_request_param', 'hash_secret_key'];

export function ConfigurationFields(props: any) {
  const { sourceConfig, sourceConfigFieldsByKey, getCurrentValueField, onChange } = props;

  const enabled = sourceConfig['hash.enabled'];
  if (Boolean(enabled) === false) return null;

  /**
   * all these fields depend on source config
   */
  return (
    <div className={styles.row}>
      {InputTypes.map((fieldName) => {
        const field = sourceConfigFieldsByKey[fieldName];
        const currentFieldValue = getCurrentValueField(fieldName) || '';

        return (
          <div key={field.name} className={classnames(styles.inputWrapper, styles.mb25)}>
            <FieldBuilderRedesigned
              field={field}
              id={field.name}
              onChange={onChange}
              showRequiredIndicator
              disabled={Boolean(props?.sourceBeingEdited)}
              isRequired={field.required}
              currentFieldValue={currentFieldValue}
              fieldLabelClassName={styles.fieldLabelClassName}
            />
          </div>
        );
      })}
    </div>
  );
}
